import { ETAPAS, type EtapaId } from '@aponte/shared';

/** Selo colorido da etapa — mesma semântica em todas as telas. */
export function SeloDeEtapa({ etapa }: { etapa: EtapaId }) {
  const { rotulo, tom } = ETAPAS[etapa];
  return <span className={`selo ${tom}`}>{rotulo}</span>;
}
